<template>
  <div class="selectlist-wrap" @click="onToggle">
    <span class="selectlist-text" v-if="selectValue">{{ selectValue }}</span>
    <span class="selectlist-text" v-else>선택해주세요</span>
    <img
      class="selectbox-arrowup-icon"
      :class="isOpenList ? 'active' : ''"
      src="/media/images/icon/selectboxarrow-down-icon.png"
      alt="arrow-up-icon.png"
    />

    <!-- SelectList -->
    <ul class="select-listbox" v-if="isOpenList">
      <li
        v-for="(item, index) in selectlist"
        :key="item.key"
        class="select-item"
        @click="clickSelect(item)"
        :class="index === selectlist.length - 1 ? 'last' : ''"
      >
        {{ item.value }}
      </li>
    </ul>
  </div>
</template>
<script>
import vClickOutside from 'v-click-outside';
export default {
  props: {
    selectvalue: {
      type: String,
      default: null,
      required: false
    },
    selectlist: {
      type: Array,
      default: () => {
        return [];
      },
      required: false
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  emits: ['open', 'click-item'],
  data() {
    return {
      isOpenList: false
    };
  },
  methods: {
    onClickOutside() {
      this.closeDropdown();
    },
    clickSelect(item) {
      this.$emit('click-item', item);
    },
    onToggle() {
      if (!this.selectlist.length) return; // NOTE: dropdown에 보여줄 리스트가 없으면 아무런 동작하지 않도록 수정
      if (!this.isOpenList) this.$emit('open'); // N개의 dropdown isOpenList값을 모두 노출하지 않도록 초기화
      this.isOpenList = !this.isOpenList;
    },
    closeDropdown() {
      this.isOpenList = false;
    }
  },
  computed: {
    selectValue() {
      const find = this.selectlist.find(item => item.key === this.selectvalue);

      if (find) {
        return find.value;
      }
      return null;
    }
  }
};
</script>
<style scoped src="@/assets/css/selectlist/selectlist.css"></style>
